<template>
    <SelectOption
        data-test="select-all-option"
        :label="label"
        :show-checkbox="false"
        :value="state.selectAllValue"
        ref="option"
    >
        <ActivixCheckbox
            class="mr-3"
            data-test="select-all-checkbox"
            size="sm"
            :tristate="true"
            :value="value"
            @input="onInput"
            v-if="state.multiple"
        />
        <span class="block truncate" data-test="select-all-label" v-text="label" />
    </SelectOption>
</template>

<script>
    import ActivixCheckbox from '../Checkbox/Checkbox.vue';
    import SelectOption from './SelectOption.vue';
    import { t } from '../../locale/index.js';

    export default {
        inject: ['state'],

        components: {
            ActivixCheckbox,
            SelectOption,
        },

        props: {
            allSelected: {
                type: Boolean,
                required: true,
            },
            partiallySelected: {
                type: Boolean,
                required: true,
            },
        },

        computed: {
            label() {
                return t('select.all');
            },

            value() {
                if (this.allSelected) {
                    return true;
                }

                if (this.partiallySelected) {
                    return null;
                }

                return false;
            },
        },

        methods: {
            onInput() {
                this.$refs.option.onSelect();
            },
        },
    };
</script>
